import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import PhotovoltaicParams from "./PhotovoltaicParams";
import WindTurbineParams from "./WindTurbineParams";
import BatteryParams from "./BatteryParams";

export const FirstStep = (props) => {
  const tabs = ["Photovoltaic", "Wind Turbine", "Battery"];
  const [activeTab, setActiveTab] = useState("Photovoltaic");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <React.Fragment>
      <Nav
        tabs
        style={{
          cursor: "pointer",
          width: "100%",
          border: "none",
        }}
      >
        {tabs.map((tab) => (
          <NavItem key={tab} style={{ width: `${100 / tabs.length}%` }}>
            <NavLink
              className={classnames({ active: activeTab === tab })}
              onClick={() => {
                toggle(tab);
              }}
              style={
                activeTab === tab
                  ? { color: "#1F5CDD", padding: 11, textAlign: "center" }
                  : { color: "black", padding: 11, textAlign: "center" }
              }
            >
              {tab}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <TabContent
        activeTab={activeTab}
        style={{
          padding: "18px 0px 0px 0px",
          border: "1px solid #DFDFDF",
          borderRadius: 3,
        }}
      >
        {tabs.map((tab) => {
          // render only the active tab --> otherwise it renders all tabs
          if (tab === activeTab) {
            return (
              <TabPane tabId={tab} key={tab}>
                {tab === "Photovoltaic" ? (
                  <PhotovoltaicParams></PhotovoltaicParams>
                ) : tab === "Wind Turbine" ? (
                  <WindTurbineParams></WindTurbineParams>
                ) : tab === "Battery" ? (
                  <BatteryParams></BatteryParams>
                ) : null}
              </TabPane>
            );
          }
        })}
      </TabContent>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  create: state.create,
});

export default connect(mapStateToProps, {})(FirstStep);
